<sag-ui-stepper
    [steps]="steps()"
    [active]="activeStepIndex()"
    [invalidSteps]="invalidSteps()"
    orientation="horizontal"
    [ariaLabel]="'workflow-transition-stepper.aria-label' | translate"
/>

@if (showValidationProgress()) {
    <div class="mt-3 flex flex-col gap-1" role="status" aria-live="polite">
        <div
            class="progress-track w-full h-2 bg-gray-200 rounded overflow-hidden"
            role="progressbar"
            [attr.aria-valuemin]="0"
            [attr.aria-valuemax]="100"
            [attr.aria-valuenow]="isDeterminate() ? validationPercentage() : null"
        >
            @if (isDeterminate()) {
                <div
                    class="h-full bg-light-actionColor dark:bg-dark-actionColor transition-all duration-300"
                    [style.width.%]="validationPercentage()"
                ></div>
            } @else {
                <div class="progress-fill-indeterminate h-full bg-light-actionColor dark:bg-dark-actionColor"></div>
            }
        </div>

        @if (isDeterminate()) {
            <div class="text-xs text-light-textColorSecondary dark:text-dark-textColorSecondary">
                {{ validationJob()?.processedProducts }} / {{ validationJob()?.totalProducts }}
                {{ 'workflow-transition-stepper.products-validated' | translate }}
            </div>
        }
    </div>
}
